import styled from 'styled-components';

export default styled.div`

  @keyframes slide-down-and-fade-in {
    0% {
      transform: translateY(0); /* Iniciar com a caixa 88px abaixo */
      opacity: 0; /* Iniciar com opacidade 0 (invisível) */
      visibility: hidden;
    }
    35% {
      transform: translateY(-1); /* Iniciar com a caixa 88px abaixo */
      opacity: 0; /* Iniciar com opacidade 0 (invisível) */
      visibility: visible;
    }
    100% {
      visibility: visible;
      transform: translateY(12px); /* Terminar com a caixa no topo */
      opacity: 1; /* Terminar com opacidade 1 (visível) */
    }
  }

  .smartplayer__footer {
    transition: transform 0.3s ease-in-out;

    & + .smartplayer__magicButtonContainer {
      transition: transform 0.3s ease-in-out;
    }
  }

  .smartplayer__footer--visible {
    transform: translateY(0);

    & + .smartplayer__magicButtonContainer {
      transform: translateY(0);
    }
  }

  .smartplayer__footer--hidden {
    transform: translateY(100px);

    & + .smartplayer__magicButtonContainer {
      transform: translateY(-100px);
    }
  }

  .smartplayer__magicButtonCbx {
    display: none;
  }

  .smartplayer__magicButtons {
    opacity: 0;
    transform: translateX(128px);
    pointer-events: none;
    gap: 0px;
    transition: opacity .4s ease-in-out, transform .25s ease-in-out, gap .2s ease-in-out;
    z-index: -1;
  }

  .smartplayer__magicButtonCbx:checked + .smartplayer__magicButton + .smartplayer__magicButtons {
    opacity: 1;
    transform: translateX(0);
    gap: 20px;
    pointer-events: auto;
  }

  .smartplayer__controlbarActions {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .smartplayer__magicButtonContainer {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row-reverse;
    position: absolute;
    max-width: 100%;
    right: 8px;
    top: 8px;
    z-index: 91;
  }

  .smartplayer__magicButton {
    height: 40px;
    background-color: var(--bg-color);
    border: 0;
    cursor: pointer;
    margin: 0 0 0 4px;
    text-rendering: optimizelegibility;
    -webkit-font-smoothing: antialiased;
    appearance: none;
    border-radius: var(--radius);
    background: var(--bg-color);
    color: var(--default-color);
    transition: opacity .25s ease-out, background-color 40ms ease-in-out, color 40ms  ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover,
    &:focus-visible {
      color: var(--hover-color);
      background: var(--primary-color);
      outline: 0;
      box-shadow: none;
    }
  }

  .smartplayer__magicButtons {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background-color: var(--bg-color);
    height: 40px;
    border-radius: var(--radius);
    padding: 0 12px;

    .smartplayer__dropdownContainer,
    .smartplayer__dropdownContainerQuality,
    .smartplayer__dropdownContainerVelocity,
    .smartplayer__dropdownContainerSubtitle {
      position: absolute;
      outline: none;
      cursor: pointer;
      display: flex;
      justify-content: center;
      background-color: var(--bg-color);
      border: 0;
      border-radius: var(--radius);
      left: 0px;
      opacity: 0;
      visibility: hidden;
      box-sizing: border-box;
      z-index: 100;
    }

    .smartplayer__configuration.smartplayer__configuration--opened .smartplayer__dropdownContainer,
    .smartplayer__ai.smartplayer__ai--opened .smartplayer__dropdownContainer {
      transform: translateY(12px);
      animation: slide-down-and-fade-in .3s ease-in-out;
    }

    .smartplayer__configuration.smartplayer__quality--opened .smartplayer__dropdownContainerQuality,
    .smartplayer__configuration.smartplayer__velocity--opened .smartplayer__dropdownContainerVelocity,
    .smartplayer__configuration.smartplayer__subtitle--opened .smartplayer__dropdownContainerSubtitle {
      transform: translateY(12px);
      animation: slide-down-and-fade-in .3s ease-in-out;
    }
  }
`;
